var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { deleteBookNotification, getBook, listBookNotifications, updateBookNotification, } from '../utils/api/bookApi';
/** Fetches the cover and metadata of the notified book. */
var NotificationBook = function (_a) {
    var notification = _a.notification;
    var _b = React.useState(null), book = _b[0], setBook = _b[1];
    React.useEffect(function () {
        var isMounted = true;
        if (!notification.isbn) {
            return function () {
                isMounted = false;
            };
        }
        getBook(notification.isbn)
            .then(function (nextBook) {
            if (isMounted && nextBook) {
                setBook(nextBook);
            }
        })
            .catch(function () {
            // We fall back to the title from the notification itself
        });
        return function () {
            isMounted = false;
        };
    }, [notification.isbn]);
    var title = (book === null || book === void 0 ? void 0 : book.title) || notification.title;
    return React.createElement("section", { className: "object book" },
        React.createElement("div", { className: "book-cover" }, (book === null || book === void 0 ? void 0 : book.imageUrl) && React.createElement("img", { src: book.imageUrl, alt: title || '' })),
        React.createElement("h2", null, notification.isbn
            ? React.createElement("a", { href: "/bok/" + notification.isbn }, title)
            : title),
        notification.isbn && React.createElement("p", null,
            "ISBN\u00A0",
            notification.isbn));
};
var NotificationRow = function (_a) {
    var notification = _a.notification, onUpdated = _a.onUpdated, onDeleted = _a.onDeleted;
    var _b = React.useState(false), isBusy = _b[0], setIsBusy = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var updateChannel = function (updates) {
        setError(null);
        setIsBusy(true);
        updateBookNotification(notification.bookId, updates)
            .then(function (updated) { return onUpdated(__assign(__assign({}, notification), updated)); })
            .catch(function () { return setError('Kunne ikke lagre endringen. Prøv igjen.'); })
            .finally(function () { return setIsBusy(false); });
    };
    var removeNotification = function () {
        if (!window.confirm('Fjerne bokvarslingen?')) {
            return;
        }
        setError(null);
        setIsBusy(true);
        deleteBookNotification(notification.bookId)
            .then(function () { return onDeleted(notification.bookId); })
            .catch(function () {
            setError('Kunne ikke fjerne bokvarslingen. Prøv igjen.');
            setIsBusy(false);
        });
    };
    return React.createElement("li", { className: "object composite" },
        React.createElement(NotificationBook, { notification: notification }),
        React.createElement("section", { className: "object notification" },
            error && React.createElement("p", { role: "alert", className: "form-error" }, error),
            React.createElement("label", null,
                React.createElement("input", { type: "checkbox", checked: notification.sendEmail, disabled: isBusy, onChange: function () { return updateChannel({ sendEmail: !notification.sendEmail }); } }),
                "Varsle meg p\u00E5 e-post"),
            React.createElement("button", { type: "button", className: "dangerous", disabled: isBusy, onClick: removeNotification }, "Slett varsling")));
};
/**
 * "Mine bokvarslinger" — lists all books the signed-in
 * user wants to be notified about when new classifieds
 * are created.
 * */
var NotificationsPage = function () {
    var _a = React.useState(null), notifications = _a[0], setNotifications = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    React.useEffect(function () {
        var isMounted = true;
        listBookNotifications()
            .then(function (nextNotifications) {
            if (isMounted) {
                setNotifications(nextNotifications || []);
            }
        })
            .catch(function () {
            if (isMounted) {
                setError('Kunne ikke hente bokvarslingene dine. Last siden på nytt for å prøve igjen.');
            }
        })
            .finally(function () {
            if (isMounted) {
                setIsLoading(false);
            }
        });
        return function () {
            isMounted = false;
        };
    }, []);
    var replaceNotification = function (next) {
        setNotifications(function (current) { return ((current || []).map(function (notification) { return (notification.bookId === next.bookId ? next : notification); })); });
    };
    var removeNotification = function (bookId) {
        setNotifications(function (current) { return (current || []).filter(function (notification) { return (notification.bookId !== bookId); }); });
    };
    if (isLoading) {
        return React.createElement("div", { className: "main-content" },
            React.createElement("h1", null, "Mine bokvarslinger"),
            React.createElement("p", null, "Laster bokvarslingene dine..."));
    }
    if (error || !notifications) {
        return React.createElement("div", { className: "main-content", role: "alert" },
            React.createElement("h1", null, "Mine bokvarslinger"),
            React.createElement("p", null, error));
    }
    return React.createElement("div", { className: "main-content" },
        React.createElement("h1", null, "Mine bokvarslinger"),
        React.createElement("p", { className: "introduction" }, "Om det ikke finnes en annonse for en bok du vil kj\u00F8pe, kan vi sende deg en melding om noen legger den ut."),
        React.createElement("div", null, notifications.length === 0
            ? React.createElement("section", null,
                React.createElement("h3", null, "Du har ingen bokvarslinger"),
                React.createElement("p", null, "For \u00E5 legge til en bokvarsling kan du s\u00F8ke etter en bok, g\u00E5 inn p\u00E5 boksiden og klikke p\u00E5 \"Opprett bokvarsling\"."))
            : React.createElement(React.Fragment, null,
                React.createElement("p", null, "Her kan du se alle b\u00F8ker du mottar varsler for."),
                React.createElement("ul", null, notifications.map(function (notification) { return React.createElement(NotificationRow, { key: notification.bookId, notification: notification, onUpdated: replaceNotification, onDeleted: removeNotification }); })))));
};
export default NotificationsPage;
